module.exports = "<div class=\"c-fullscreen-cover__background\">\n  <figure>\n    <img src=\"{{backgroundImage}}\" alt=\"\">\n  </figure>\n</div>\n<div class=\"c-fullscreen-cover__content\">\n  <ng-content></ng-content>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/fullscreen-cover/fullscreen-cover.component.html
// module id = ./src/app/modules/common-module/components/fullscreen-cover/fullscreen-cover.component.html
// module chunks = 9